// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export { TableRole } from './interfaces';

export {
  getTableCellRoleProps,
  getTableColHeaderRoleProps,
  getTableHeaderRowRoleProps,
  getTableRoleProps,
  getTableRowRoleProps,
  getTableWrapperRoleProps,
} from './table-role-helper';

export { GridNavigationProvider } from './grid-navigation';



// WEBPACK FOOTER //
// /Volumes/brazil-workspaces/Phoenix/src/table/table-role/index.ts